import React, {useMemo} from 'react';
import type {ManifestationCardProps} from './types';
import {useGetWorkEditValue} from 'services/metadata';
import {useManifestationCount} from '../../hooks';
import {ManifestationCardCore} from './ManifestationCardCore';
import {ManifestationRestrictedCodelists} from './components/ManifestationRestrictedCodelists';
import {useManifestationEditState} from './hooks';

export const ManifestationCard: React.FC<ManifestationCardProps> = props => {
  const editState = useManifestationEditState(props);

  const getWorkEditValue = useGetWorkEditValue();
  const prizes = getWorkEditValue('prizes', props.workId);
  const manifestationCount = useManifestationCount();

  const moveAndDeleteDisabled = useMemo(() => {
    const hasPrizes = Array.isArray(prizes) && prizes.length > 0;

    return manifestationCount < 2 && hasPrizes;
  }, [manifestationCount, prizes]);

  return (
    <ManifestationRestrictedCodelists
      expressionId={props.expressionId}
      manifestationId={props.manifestationId}>
      <ManifestationCardCore
        props={{
          deleteDisabled: moveAndDeleteDisabled,
          moveDisabled: moveAndDeleteDisabled,
          ...props,
        }}
        editState={editState}
      />
    </ManifestationRestrictedCodelists>
  );
};
